import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.WOW === "function") {
      const wow = new window.WOW();
      wow.init();
    }

    if (!location.hash) {
      // Scroll to the top instantly when the route changes
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant", // Ensures no delay
      });
      return;
    }

    const id = location.hash.slice(1);

    const scrollToTarget = () => {
      const target = document.getElementById(id);
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };

    // Scroll once shortly after mount, then re-align whenever an image
    // finishes loading (images above the target can shift its position
    // after the first scroll has already run).
    const timer = setTimeout(scrollToTarget, 100);

    const pendingImages = Array.from(document.images).filter((img) => !img.complete);
    pendingImages.forEach((img) => img.addEventListener("load", scrollToTarget));

    return () => {
      clearTimeout(timer);
      pendingImages.forEach((img) => img.removeEventListener("load", scrollToTarget));
    };
  }, [location.pathname, location.hash]);

  return children;
};

export default ScrollToTop;